export default "__VITE_ASSET__Bq2er5D9__"